import authorizationIcon from "./assets/images/authorization-icon.svg";
import facilityIcon from "./assets/images/facility-icon.svg";
import fittingsIcon from "./assets/images/fittings-icon.svg";
import ordersIcon from "./assets/images/orders-icon.svg";
import repsIcon from "./assets/images/reps-icon.svg";
import retailIcon from "./assets/images/retail-icon.svg";
import {REP_TYPE_IDS} from "./constants";
import ClaimCategoriesPage from "./screens/claimCategories/ClaimCategoriesPage";
import ClaimsPage from "./screens/claims/ClaimsPage";
import GroupsPage from "./screens/groups/GroupsPage";
import UserTypesPage from "./screens/userTypes/UserTypesPage";
import EventsTable from "./screens/events/EventsTable";
import FacilitiesTable from "./screens/facilities/FacilitiesTable";
import FacilityDetails from "./screens/facilities/FacilityDetails";
import FittingsTable from "./screens/fittings/FittingsTable";
import RepsTable from "./screens/reps/RepsTable";
import CreateUserWizard from "./screens/reps/createUser/CreateUserWizard";
import UserDetails from "./screens/reps/viewEditUser/UserDetails";
import RetailLocationsTable from "./screens/retailLocations/RetailLocationsTable";
import SignIn from "./screens/SignIn";
import ResetPassword from "./screens/ResetPassword";

const routes = [
    {
        name: "Manage Users",
        key: "reps",
        path: "/users",
        icon: repsIcon,
        authRequired: true,
        component: <RepsTable />,
        visibleRepTypes: [1, 2, 3, 4, 5, 6, 8, 10],
    },
    {
        name: "Create User",
        key: "create-user",
        path: "/users/create",
        component: <CreateUserWizard />,
        authRequired: true,
        visibleRepTypes: [],
    },
    {
        name: "View / Edit User",
        key: "user-details",
        path: "/users/:id",
        component: <UserDetails />,
        authRequired: true,
        visibleRepTypes: [],
    },
    {
        name: "Manage Events",
        key: "events",
        icon: ordersIcon,
        path: "/events",
        authRequired: true,
        component: <EventsTable />,
        visibleRepTypes: [1, 2, 3, 4, 5, 6, 8, 9],
    },
    {
        name: "Manage Fittings",
        key: "fittings",
        icon: fittingsIcon,
        path: "/fittings",
        authRequired: true,
        component: <FittingsTable />,
        visibleRepTypes: [1, 2, 3, 4, 5, 6, 8, 9],
    },
    {
        name: "Manage Facilities",
        key: "facilities",
        icon: facilityIcon,
        path: "/facilities",
        component: <FacilitiesTable />,
        authRequired: true,
        visibleRepTypes: [1],
    },
    {
        name: "Facility Details",
        key: "facility-details",
        path: "/facilities/:id",
        component: <FacilityDetails />,
        authRequired: true,
        visibleRepTypes: [],
    },
    {
        name: "Retail Locations",
        path: "/retail-locations",
        key: "retail-locations",
        icon: retailIcon,
        component: <RetailLocationsTable />,
        authRequired: true,
        visibleRepTypes: [1, 7],
    },
    {
        name: "Claim Categories",
        path: "/claim-categories",
        key: "claim-categories",
        icon: authorizationIcon,
        section: "Authorization",
        component: <ClaimCategoriesPage />,
        authRequired: true,
        visibleRepTypes: [REP_TYPE_IDS.globalAdmin],
    },
    {
        name: "Claims",
        path: "/claims",
        key: "claims",
        icon: authorizationIcon,
        section: "Authorization",
        component: <ClaimsPage />,
        authRequired: true,
        visibleRepTypes: [REP_TYPE_IDS.globalAdmin],
    },
    {
        name: "Groups",
        path: "/groups",
        key: "groups",
        icon: authorizationIcon,
        section: "Authorization",
        component: <GroupsPage />,
        authRequired: true,
        visibleRepTypes: [REP_TYPE_IDS.globalAdmin],
    },
    {
        name: "User Types",
        path: "/user-types",
        key: "user-types",
        icon: authorizationIcon,
        section: "Authorization",
        component: <UserTypesPage />,
        authRequired: true,
        visibleRepTypes: [REP_TYPE_IDS.globalAdmin],
    },
    {
        name: "Sign In",
        key: "sign-in",
        path: "/sign-in",
        component: <SignIn />,
    },
    {
        name: "Reset Password",
        key: "reset-password",
        path: "/reset-password",
        component: <ResetPassword />,
        visibleRepTypes: [],
    },
];

export default routes;
